import styled, { css } from 'styled-components';
import { FontSizes } from '../../../../common/typography/typography.styles';
import betaPanel from './beta-panel.svg';

export const ParcelItemsAiLoadingOverlayContainer = styled.div`
  position: fixed;
  inset: 0;
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100dvh;
  padding: 2.4rem;
  background-color: rgba(255, 255, 255, 0.72);
  -webkit-backdrop-filter: blur(4px);
  backdrop-filter: blur(4px);

  .ai-loading-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2.4rem;
    width: min(100%, 45.6rem);
    color: ${({ theme }) => theme.colors.baseColors.grey150};
    text-align: center;
  }

  .ai-loading-spinner {
    display: block;
    width: 4rem;
    height: 4rem;
    border-radius: 50%;
    background: conic-gradient(
      from -90deg,
      #4f39f6 0deg,
      #0072ff 300deg,
      transparent 300deg
    );
    -webkit-mask: radial-gradient(
      farthest-side,
      transparent calc(100% - 0.3rem),
      #000 0
    );
    mask: radial-gradient(
      farthest-side,
      transparent calc(100% - 0.3rem),
      #000 0
    );
    animation: ai-loading-spin 1s linear infinite;
  }

  .ai-loading-copy {
    width: 100%;
  }

  h2,
  p {
    margin: 0;
    letter-spacing: 0.5px;
  }

  h2 {
    font-size: ${FontSizes.mediumBig};
    font-weight: 700;
    line-height: 3rem;
  }

  p {
    margin-top: 0.4rem;
    font-size: ${FontSizes.normal};
    font-weight: 500;
    line-height: 2rem;
  }

  @keyframes ai-loading-spin {
    to {
      transform: rotate(360deg);
    }
  }

  @media (prefers-reduced-motion: reduce) {
    .ai-loading-spinner {
      animation-duration: 2s;
    }
  }
`;

const aiIconButtonStyles = css`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  background: none;
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.namedColors.focus};
    outline-offset: 2px;
    border-radius: 0.4rem;
  }
`;

export const ParcelItemsAiBetaPanelContainer = styled.div`
  position: relative;
  min-height: 11.2rem;
  margin: 0.8rem 0 1.6rem;
  padding: 2rem 1.6rem 3.2rem;
  background: url(${betaPanel}) center / 100% 100% no-repeat;
  color: ${({ theme }) => theme.colors.baseColors.grey150};
  text-align: center;
  word-break: normal;

  h3,
  p {
    margin: 0;
    font-size: ${FontSizes.normal};
    letter-spacing: 0.5px;
  }

  h3 {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.4rem;
    padding: 0 2rem;
    font-weight: 700;
    line-height: 1.6rem;
  }

  p {
    margin-top: 0.2rem;
    line-height: 2rem;
  }

  .sparkle-icon {
    display: inline-flex;
    flex-shrink: 0;

    svg {
      width: 1.8rem;
      height: 1.8rem;
    }
  }

  .ai-beta-tag {
    position: absolute;
    top: -0.8rem;
    left: 0.8rem;
    padding: 0.3rem 1rem;
    border: 1px solid ${({ theme }) => theme.colors.baseColors.green90};
    border-radius: 2.4rem;
    background: ${({ theme }) => theme.colors.baseColors.green90};
    color: ${({ theme }) => theme.colors.namedColors.white};
    font-size: ${FontSizes.small};
    font-weight: 500;
    line-height: normal;
  }

  .ai-beta-close {
    ${aiIconButtonStyles};
    position: absolute;
    top: 0;
    right: 0;
    padding: 1.2rem;

    > svg {
      width: 16px;
    }
  }
`;

export const ParcelItemsAiControlsContainer = styled.div`
  position: absolute;
  z-index: 2;
  top: 50%;
  right: 1.6rem;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  gap: 1.2rem;

  .ai-action-trigger {
    display: flex;
    width: 2rem;
    height: 2rem;
  }

  .ai-review-tooltip {
    position: absolute;
    top: calc(100% + 2.2rem);
    right: 0;
    z-index: 2;
    width: min(28rem, calc(100vw - 6.4rem));
    padding: 1.2rem 1.6rem;
    border: 1px solid ${({ theme }) => theme.colors.namedColors.primary};
    border-radius: 1.2rem;
    background: ${({ theme }) => theme.colors.namedColors.white};
    color: ${({ theme }) => theme.colors.baseColors.grey150};
    box-shadow: 0 0.4rem 1.2rem ${({ theme }) => theme.colors.baseColors.grey50};
    font-size: ${FontSizes.small};
    line-height: 1.6rem;
    letter-spacing: 0.5px;
    word-break: normal;
    pointer-events: none;
    visibility: hidden;
  }

  &:hover,
  &:focus-within {
    .ai-review-tooltip {
      visibility: visible;
    }
  }

  button {
    ${aiIconButtonStyles};
    width: 2rem;
    height: 2rem;

    &:disabled {
      pointer-events: none;
      cursor: default;
      opacity: 0.65;
    }
  }
`;
